import React from "react";

type BadgeVariant = "success" | "danger" | "warning" | "info" | "highlight";
type BadgeSize = "xs" | "sm" | "md" | "lg" | "xl";

type BadgeProps = {
  variant: BadgeVariant;
  children: React.ReactNode;
  size?: BadgeSize
};

const Badge: React.FC<BadgeProps> = ({ variant, children, size="sm" }) => {

    const getFontClass = () => {
        switch(size){
            case "xs":
                return "font-8";
            case "sm":
                return "font-10";
            case "md":
                return "font-12";
            case "lg":
                return "font-14";
            case "xl":
                return "font-16"
            default:
                return ""
        }
    }

  return <span className={`badge p-2 ${getFontClass()} rounded-sm bg-${variant}`}>{children}</span>;
};

export default Badge;